export const BUSINESS = {
  name: "Adelaide Premium Detailing",
  short: "APD",
  phone: "0426 219 937",
  phoneRaw: "0426219937",
  email: "Adelaidepremiumdetailing@outlook.com",
  area: "Adelaide, South Australia",
  areasServed: ["Adelaide CBD", "North Adelaide", "Glenelg", "Norwood", "Prospect", "Burnside", "Unley", "Port Adelaide"],
};

export const HERO_IMAGE =
  "https://images.pexels.com/photos/17092455/pexels-photo-17092455.png?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920";

export const MANIFESTO_IMAGE =
  "https://images.pexels.com/photos/18320398/pexels-photo-18320398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920";

export const SERVICES = [
  {
    key: "ceramic",
    title: "Ceramic Coating",
    line: "Multi-year gloss & protection. Hydrophobic, UV-stable, self-cleaning.",
    detail: "9H-rated coatings that lock in depth of gloss and repel water, dirt and contaminants for years — not weeks.",
    path: "quote",
    image:
      "https://images.pexels.com/photos/32474952/pexels-photo-32474952.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    key: "correction",
    title: "Paint Correction",
    line: "Cut, refine & polish out swirls, holograms and oxidation.",
    detail: "Multi-stage machine correction that removes the defects light hides — restoring a mirror finish underneath.",
    path: "quote",
    image:
      "https://images.pexels.com/photos/11139244/pexels-photo-11139244.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    key: "interior",
    title: "Interior Detail",
    line: "Deep extraction, steam, leather & trim conditioning.",
    detail: "Every surface hand-treated — carpets extracted, leather fed, plastics dressed, glass streak-free.",
    path: "book",
    image:
      "https://images.unsplash.com/photo-1687634366070-c06d3f037154?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "exterior",
    title: "Exterior Detail",
    line: "Decontamination, clay, machine polish & sealant.",
    detail: "A safe wash system, iron & tar removal, and a sealed, slick finish that beads on the first rain.",
    path: "book",
    image:
      "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const MANIFESTO = [
  { n: "01", title: "Correction, not concealment", body: "We remove defects — we don't fill them. What you see is real, restored paint." },
  { n: "02", title: "Coatings that last", body: "Certified 9H ceramic systems, applied in a controlled bay, cured properly." },
  { n: "03", title: "Cars, bikes & boats", body: "One obsession across every surface — chrome, gel-coat, leather and clear-coat." },
  { n: "04", title: "Adelaide local", body: "Servicing greater Adelaide with pickup options across the metro area." },
];

export const GALLERY = [
  { id: 1, type: "car", label: "Black coupe · gloss enhancement", image: "https://images.unsplash.com/photo-1526459915562-c5ca724b1d02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { id: 2, type: "car", label: "Correction & ceramic", image: "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { id: 3, type: "car", label: "Wheel & paint detail", image: "https://images.unsplash.com/photo-1690022676526-2762ac826843?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { id: 4, type: "car", label: "Interior restoration", image: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { id: 5, type: "bike", label: "Chrome polish & seal", image: "https://images.unsplash.com/photo-1777104782087-5c5d762cb32a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { id: 6, type: "bike", label: "Cruiser deep clean", image: "https://images.pexels.com/photos/4513014/pexels-photo-4513014.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1000" },
  { id: 7, type: "bike", label: "Engine bay detail", image: "https://images.pexels.com/photos/13023826/pexels-photo-13023826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1000" },
  { id: 8, type: "boat", label: "Hull cut & polish", image: "https://images.unsplash.com/photo-1585000962552-70f0a67223d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { id: 9, type: "boat", label: "Gel-coat restoration", image: "https://images.pexels.com/photos/17192715/pexels-photo-17192715.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1000" },
  { id: 10, type: "boat", label: "Marine ceramic coat", image: "https://images.unsplash.com/photo-1562281302-809108fd533c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
];

export const REVIEWS = [
  { name: "Marcus T.", vehicle: "BMW M4", text: "Booked the full detail and paid the deposit in two minutes. The paint correction is unreal — looks better than showroom.", rating: 5 },
  { name: "Priya S.", vehicle: "Range Rover", text: "Ceramic coating quote was fast and honest. Water just rolls off now. Best detailer in Adelaide, hands down.", rating: 5 },
  { name: "Dylan K.", vehicle: "Harley Softail", text: "Nobody touches bikes like these guys. Chrome is a mirror. Already re-booked for summer.", rating: 5 },
  { name: "Elena R.", vehicle: "Sea Ray boat", text: "Gel-coat was chalky and tired — now it gleams. Professional, on time, worth every dollar.", rating: 5 },
  { name: "Sam W.", vehicle: "Golf GTI", text: "Interior looked brand new. The deposit booking made it painless. Highly recommend.", rating: 5 },
];

export const VEHICLE_TYPES = [
  { key: "car", label: "Car" },
  { key: "bike", label: "Bike" },
  { key: "boat", label: "Boat" },
];

export const VEHICLE_SIZES = ["Small / compact", "Medium sedan", "Large SUV / 4WD", "Van / dual-cab", "Oversized / commercial"];
